module.exports = __webpack_public_path__ + "178c5ef49a063f8c6f3eee5e4f073516.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room4/audio1/04_MCA Administrating Eternity.mp3
// module id = 782
// module chunks = 0